
export enum eFASTLINK_SUBCOMMAND
{
  eREQUESTED_OLDCOMMAND = 0,            // The old command
  eREQUESTED_TEST = 1,
  eREQUESTED_GENERAL = 32,        //sFARLINK last received data
  eREQUESTED_PRESENCE = 33,       //sFARLINK present detection
  eREQUESTED_VELDSTATIONS = 64,   // _sVELD
  eREQUESTED_FASTLINKS = 128,     // _sFASTLINK

  eREQUESTED_SCREEN = 16,
  eREQUESTED_KEY_UP = 17,
  eREQUESTED_KEY_DOWN = 18,
  eREQUESTED_KEY_ENTER = 19,
  eREQUESTED_KEY_GRAPH = 20,
}


export interface CFASTLINKMAPFARLINK {
  fastlinkNr: number;
  lastFastlink: number;
  initRejected: number;
  completed: number;
  minimumVersie: number;
  minimumRevisie: number;
  versionBlock: number;
  sysOptions: number;
  klimaatEnabled: number;
  klimaatState: number;
  climLink: number;
  ioXChange: number;
  vereisteVeldStations: number;
  aantalVeldStations: number;
  vereisteFastlinks: number;
  aantalFastlinks: number;
  activeFastlinks: number;
  hoogsteFastlink: number;
  presentIoTypes: number;
  offsetDi: number;
  offsetDo: number;
  offsetAi: number;
  offsetAo: number;
  aantalDi: number;
  aantalDo: number;
  aantalAi: number;
  aantalAo: number;
}

export interface CFASTLINKMAPPERVELDSTATION {
  station: number;
  status: number;
  errorCode: number;
  version: number;
  revision: number;
}

export interface CFASTLINKMAPPERFASTLINK {
  fastlinkstation: number;
  status: number;
  nummerVeldstation: number;
  nrOfDIs: number;
  nrOfDOs: number;
  nrOfAIs: number;
  nrOfAOs: number;
  offsetDI: number;
  offsetDO: number;
  offsetAI: number;
  offsetAO: number;
}


export interface CFASTLINKMAPPER {
  timestamp: number;
  cFASTLINK_MAP_FARLINK: CFASTLINKMAPFARLINK;
  cFASTLINK_MAPPER_VELDSTATION: CFASTLINKMAPPERVELDSTATION[];
  cFASTLINK_MAPPER_FASTLINK: CFASTLINKMAPPERFASTLINK[];
}

export interface FASTLINKDATA {
  cFASTLINK_MAPPER_JSON: number;
  finalizedOnce: number;
  isenabled: number;
  cFASTLINK_MAPPER_RUNTIME: CFASTLINKMAPPER;
  cFASTLINK_MAPPER_BLUEPRINT: CFASTLINKMAPPER;
}



export interface FASTLINKLCD {
  lcddata0: string;
  lcddata1: string;
}





